<template>
  <div>
    <div class="x-banner">
      <!-- banner -->
      <BANNER></BANNER>
    </div>
    <div class="container-width location">
      当前位置:<router-link to="/">首页</router-link> > 搜索词：
      {{ searchContent }}
    </div>
    <div class="container-width">
      <div class="search_body pull-left">
        <div
          class="search_body_list"
          v-for="(item, index) in list"
          :key="index"
        >
          <a class="search_body_list_tit" @click="godoctor(item.id)">{{
            item.name
          }}</a>
          <p></p>
          <p class="detail">
            <span>性别: {{ item.sex }} </span>
            <span>职称: {{ item.zhicheng }}</span>
            <span>科室: {{ item.departName }}</span>
          </p>
        </div>
        <div class="pagination">
          <nav>
            <Pagination
              :pageCount="totalPages"
              :total="total"
              @togglePage="togglePage($event)"
            ></Pagination>
          </nav>
        </div>
      </div>
    </div>
  </div>
  
</template>

<script>
import service from "../../service/ylts";
import BANNER from "../../components/banner/ylts";
export default {
  name: "SEARCH",
  props: {},
  data() {
    return {
      pageIndex: 1,
      pageSize: window.screen.width < 720 ? 6 : 10,
      totalPages: 1,
      currentPage: 1,
      list: [],
      total: 0,
      searchContent: "",
      currentPath: "",
      navigationData: [],
    };
  },
  components: { BANNER },
  methods: {
    godoctor(id) {
      let articleId = id;
      const { href } = this.$router.resolve({
        path: `/ylts/mingyi/doctor/${articleId}`,
      });
      window.open(href, "_self");
    },

    handleSearchDisease() {
      let parmes = {
        word: this.searchContent,
        pageIndex: this.pageIndex,
        pageSize: this.pageSize,
        isshow: 1,
      };
      service.getDiseaseList(parmes, (res) => {
        this.totalPages = parseInt(res.totalPages) || 0;
        this.total = res.totalElements;
        this.list = res.content || [];
      });
    },

    handleSearchDoctor() {
      let parmes = {
        word: this.searchContent,
        pageIndex: this.pageIndex,
        pageSize: this.pageSize,
        isshow: 1,
      };
      service.getDocDepartList(parmes, (res) => {
        this.totalPages = parseInt(res.totalPages) || 0;
        this.total = res.totalElements;
        this.list = res.content || [];
      });
    },

    togglePage(indexPage) {
      this.pageIndex = indexPage;
      if (this.type == "disease") {
        this.handleSearchDisease();
      } else {
        this.handleSearchDoctor();
      }
    },
  },
  created() {
    this.type = this.$route.query.type;
    this.searchContent = this.$route.query.searchContent;

    if (this.type == "disease") {
      this.handleSearchDisease();
    } else {
      this.handleSearchDoctor();
    }
  },
  mounted() {},
};
</script>

<style scoped lang="scss">
.search_body {
  width: 100%;
}
.red {
  color: red;
}
.search_body_list {
  padding: 10px 0px;
  padding-bottom: 20px;
  border-bottom: 1px dotted #ccc;
}
.search_body_list_tit {
  font-size: 18px;
  margin: 10px 0;
  display: block;
}
.search_body_list p {
  font-size: 14px;
  color: #737373;
  line-height: 24px;
}
a {
  color: #428bca;
  cursor: pointer;
}
.detail span {
  margin-right: 20px;
}
.pagination {
  display: -webkit-box;
  display: -moz-box;
  display: -ms-flexbox;
  display: -webkit-flex;
  display: flex;
  -webkit-justify-content: center;
  justify-content: center;
}
</style>
